
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/info",
      function () {
        return require("private-next-pages/account/info/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/info"])
      });
    }
  